import { Injectable } from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree} from '@angular/router';
import { Observable } from 'rxjs';
import {MsalService} from "@azure/msal-angular";
import {AuthService} from "@services";

@Injectable({
  providedIn: 'root'
})
export class RegisterGuard implements CanActivate {

  constructor(private msalAuthService: MsalService,
              private authService: AuthService,
              private route: Router) {
  }
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    const userLogged = this.authService.getLoggedUser();

    console.log(userLogged);
    if(userLogged!=null)
    {
      if (userLogged.roles[0] == null || userLogged.roles.length == 0) {

        return true;
      } else {
        this.route.navigateByUrl('/');
        return false;
      }
    }
    else
    {
      this.route.navigateByUrl('/');
      return false;
    }

  }

}
